import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { cl } from '@fullcalendar/core/internal-common';
import { PromoTypeEnum } from 'app/models';
import { PartnerMarketingPromotionsComponent } from 'app/partner';
import * as moment from 'moment';

@Component({
    selector: 'partner-marketing-filter-promotion',
    templateUrl: './partner-marketing-filter-promotion.component.html',
    styleUrls: ['./partner-marketing-filter-promotion.component.scss',
        '../../../../../styles/sidebar.scss',
        '../../../../../styles/style-layout.scss'
    ]
})
export class PartnerMarketingFilterPromotionComponent implements OnInit {

    @Input()
    public visiblePartnerMarketingFilterPromotion: boolean = false;

    @Input() partnerMarketingPromotionsComponent!: PartnerMarketingPromotionsComponent;

    public filterObj: any = {};
    @Input()
    set _filterObj(obj: any) {
        this.filterObj = obj;
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = new Date(this.filterObj.StartedAt);
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = new Date(this.filterObj.ValidUntil);
        }
    }

    @Output() changedShowPartnerMarketingFilterPromotionSideBarEmit = new EventEmitter<boolean>();
    changedShowPartnerMarketingFilterPromotionSideBar(increased: boolean) {
        this.changedShowPartnerMarketingFilterPromotionSideBarEmit.emit(increased);
    }

    constructor() { }

    public promoTypeEnum = PromoTypeEnum;

    ngOnInit(): void {}

    public clickStatus(status: string) {
        this.filterObj.Status = status;
    }

    public uncheckFilter() {
        this.filterObj = {};
    }

    public clickFilter() {
        this.filterObj.PromoTypeId = +this.filterObj.PromoTypeId;
        if (this.filterObj.StartedAt) {
            this.filterObj.StartedAt = moment(this.filterObj.StartedAt).format('YYYY-MM-DD');
        }
        if (this.filterObj.ValidUntil) {
            this.filterObj.ValidUntil = moment(this.filterObj.ValidUntil).format('YYYY-MM-DD');
        }
        this.partnerMarketingPromotionsComponent.getMerchantPromos(0, this.filterObj);
        this.cancel();
    }

    public cancel() {
        this.changedShowPartnerMarketingFilterPromotionSideBar(false);
    }
}
